import script from "./RichMenuEdit.vue?vue&type=script&lang=ts&setup=true"
export * from "./RichMenuEdit.vue?vue&type=script&lang=ts&setup=true"

import "./RichMenuEdit.vue?vue&type=style&index=0&id=1e915f54&lang=scss&scoped=true"

import exportComponent from "/home/crmfront/lineCRM-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e915f54"]])

export default __exports__